import React, { FC, useMemo } from 'react';
import { JobData } from '@/types';
import { timeConverter } from '@/utils/helpers';
import { useTranslate } from '@/translations';
import { CustomColumns, CustomTable } from '../../CustomTable';
import { faCheck, Icon } from '../../Icon';

type JobsDataGridProps = {
  jobs?: JobData[];
};
export const JobsDataGrid: FC<JobsDataGridProps> = ({ jobs }) => {
  const { t } = useTranslate();
  const columns: CustomColumns<JobData> = useMemo(
    () => [
      {
        dataIndex: 'jobType',
        title: 'Job Type',
        sortable: true,
        filter: true,
        width: 120,
      },
      {
        dataIndex: 'jobStatus',
        title: 'Status',
        sortable: true,
        filter: true,
        width: 150,
        align: 'center',
      },
      {
        dataIndex: 'location',
        title: 'Site',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        dataIndex: 'jobNotes',
        title: t('notes'),
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        dataIndex: 'externalRef',
        title: 'External Ref',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        dataIndex: 'createdAt',
        title: 'Create Date',
        renderType: 'date',
        width: 180,
        sortable: true,
        filter: true,
        render: (value) => timeConverter(value),
      },
      {
        dataIndex: 'createdBy',
        title: 'Created By',
        sortable: true,
        filter: true,
        width: 120,
        align: 'center',
      },
      {
        dataIndex: 'updatedAt',
        title: 'Update Date',
        renderType: 'date',
        width: 180,
        sortable: true,
        filter: true,
        render: (value) => timeConverter(value),
      },
      {
        dataIndex: 'updatedBy',
        title: 'Updated By',
        sortable: true,
        filter: true,
        width: 120,
        align: 'center',
      },
      {
        dataIndex: 'completedAt',
        title: 'Complete Date',
        renderType: 'date',
        width: 180,
        sortable: true,
        filter: true,
        render: (value) => timeConverter(value),
      },
      {
        dataIndex: 'completedBy',
        title: 'Completed By',
        sortable: true,
        filter: true,
        width: 120,
        align: 'center',
      },
      {
        dataIndex: 'jobId',
        title: 'Deleted',
        render: (value) => (value ? <Icon icon={faCheck} /> : null),
        width: 90,
        align: 'center',
      },
    ],
    [t],
  );

  return (
    <CustomTable
      dataSource={jobs || []}
      columns={columns}
      rowKey="jobId"
      scroll={{ x: true }}
    />
  );
};
